import { Swiper } from "swiper"
import { getElements } from "@oddcamp/js-utils/src/selector"

import init from "../../shared/utils/init"

// swiper

init(() => {
  getElements(`.vb-img-carousel, .vb-web-img-carousel`).forEach(
    (containerEl) => {
      new Swiper(containerEl.querySelector(`.swiper`), { loop: true })

      containerEl
        .querySelector(`.swiper-button-next`)
        .addEventListener(`click`, () => {
          containerEl.querySelector(`.swiper`).swiper.slideNext()
        })

      containerEl
        .querySelector(`.swiper-button-prev`)
        .addEventListener(`click`, () => {
          containerEl.querySelector(`.swiper`).swiper.slidePrev()
        })
    }
  )
})
